import _get from 'lodash/get';
/**
 *
 * @module PluginManager
 * @desc Manages the creation of player plugins
 * @class PluginManager
 *
 */

class PluginManager {

    /**
     *
     * @constructor
     * @param config {MediaPlayerConfig}
     * @param observationCenter {ObservationCenter}
     *
     */
    constructor(config, observationCenter) {

        /**
         *
         * @type {MediaPlayerConfig}
         *
         */
        this.config = config;

        /**
         *
         * @desc Reference to the @link ObservationCenter
         * @type {ObservationCenter}
         *
         */
        this.observationCenter = observationCenter;

        /**
         *
         * @desc List of plugins that have been creatd for the player
         * @type {Array}
         *
         */
        this.plugins = [];

        /**
         *
         * @desc Map of available plugins
         * @type {object}
         *
         */
        this.pluginsMap = {};


        this.createPlugins();

    }

    /**
     *
     * @desc Creates the plugins specified in the pluginConfigs list
     *
     */
    createPlugins() {

        const pluginConfigList = this.config.pluginConfigs;

        if(pluginConfigList.length) {

            pluginConfigList.forEach((pluginConf) => {

                try {

                    const newPlugin = new pluginConf.pluginReference(pluginConf.config, this.observationCenter);

                    this.plugins.push({
                        plugin: newPlugin,
                    });

                    this.pluginsMap[_get(pluginConf, 'config.name')] = newPlugin;

                } catch(error) {

                    throw error;

                }

            });

        }

    }

    /**
     *
     * @desc Gets a reference to the plugin by name
     * @param {string} pluginName
     *
     */
    getPlugin(pluginName) {

        return this.pluginsMap[pluginName];

    }

}

export default PluginManager;
